<template class="s">
	<div :id="baseId" :class="allClass">
		<div class="slide slide_info">
			<div class="infographic">
				<img src="/images/home/v6/infographic-2.png" alt="img" />
				<div class="expo">
					<h1>No Coding Required</h1>
					<p>Stan is the simplest and easiest way to get started. You can build your Store in just a few minutes!</p>
				</div>
			</div>

			<div class="infographic right">
				<img src="/images/home/v6/infographic-1.png" alt="img" />
				<div class="expo">
					<h1>1-Tap Checkout</h1>
					<p>Your audience shouldn’t have to go through hurdles to purchase your product. Stan maximizes your checkout conversion rates.</p>
				</div>
			</div>

			<div class="infographic first">
				<img src="/images/home/v6/infographic.png" alt="img" />
				<div class="expo">
					<h1>Integrates with Your Favorite Apps</h1>
					<p>Stan integrates with all the third party tools you use.</p>
				</div>
			</div>
		</div>

		<div :id="addonId" class="setup-steps-panel-try-stan-block addon">
			<h3>Try Stan for 14 Days Free</h3>
			<button class="panel-button" @click="$emit('register')">
				<div class="panel-button-content">
					<div class="panel-button-content--text">Start My Trial</div>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
	import { computed, defineComponent } from 'vue'

	export default defineComponent({
		name: 'LandingV6SetupSteps',
		props: {
			id: {
				type: [String, Number],
			},
			class: { type: [String] },
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const allClass = computed(() => `setup-steps-panel ${props.class}`)

			return {
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
				allClass,
			}
		},
	})
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	#setup {
		background: white;
	}

	.slide_info {
		image-rendering: -webkit-optimize-contrast;
		background: white;
		.infographic {
			width: 100vw;
			display: flex;
			align-items: center;
			img {
				height: 400px;
			}
			.expo {
				width: 600px;
				max-width: 100%;
				padding: 1vw;

				h1 {
					font-size: 44px;
					line-height: 120%;
					font-weight: 800;
					margin: 0;
					margin-bottom: 30px;
				}

				p {
					font-family: Inter, Plus Jakarta Sans, sans-serif;
					letter-spacing: -0.3px;
					font-size: 18px;
					font-weight: 300;
					line-height: 130%;
					margin: 0;
				}
			}

			&.right {
				flex-direction: row-reverse;
				text-align: right;
			}
		}
	}

	@media screen and (max-width: 800px) {
		.slide_info {
			background: white;
			.infographic {
				width: 100vw;
				height: 40vw;
				display: flex;
				flex-direction: column;
				gap: 0px;
				margin-bottom: 400px;
				img {
					width: 100vw;
					margin-bottom: 100px;
				}

				.expo {
					width: 80vw;
					padding: 8vw;
					margin-top: -20vw;

					h1 {
						font-size: 28px;
						font-weight: 800;
					}

					p {
						font-size: 16px;
						line-height: 150%;
					}
				}

				&.right {
					flex-direction: column;
					align-items: flex-end;
					text-align: right;
				}
			}
		}

		.addon {
			height: 400px !important;
			padding: 0 !important;
			margin-top: -200px !important;
			padding-bottom: 150px !important;
		}
	}

	.landing-page-component {
		&.setup-steps-panel,
		&.setup-steps-panel-try-stan-block {
			box-sizing: unset;
			padding-bottom: 80px;
			padding-top: 130px;
			@media (max-width: $primary-mobile-breakpoint-px) {
				box-sizing: unset;
				padding-top: -300px;
			}
		}
	}

	.setup-steps-panel {
		&-try-stan-block {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: auto;
			--max-size: 100;
			--min-size: 63;
			padding-top: min(calc(1px * var(--max-size)), var(--responsive));
			padding-left: max(15px, calc(var(--responsive) - 75px));
			padding-bottom: 77px;

			h3,
			button.panel-button {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				font-weight: 800;
				padding-left: 19px;
			}

			h3 {
				--max-size: 50;
				--min-size: 24;
				font-size: 36px;
				line-height: 105%;
				text-align: center;
				letter-spacing: 0.009em;
				margin-bottom: 60px;
				@media (max-width: var(--primary-mobile-breakpoint-px)) {
					& {
						font-size: 24px;
						margin-bottom: 30px;
					}
				}
			}

			.panel-button {
				width: 80%;
				max-width: 320px;

				border: none;
				background: #131f60;
				box-shadow: 0 40px 40px rgba(0, 0, 0, 0.1);
				border-radius: 50px;
				transition: 0.2s ease;
				height: fit-content;

				padding: 28px 0 32px 0;

				&:hover {
					background: #090e2a;
				}
				&-content {
					padding: 0;
					&--text {
						color: #ffffff;
						font-size: 24px;
						line-height: 100%;
						font-weight: 700;
						text-align: center;
						transform: translateX(-10px);
					}
				}
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				margin: unset;
				padding-top: 44px;
				padding-left: 0;

				transform: translateY(120px);

				h3 {
					font-size: 24px;
					margin-bottom: 25px;
					padding-left: 0;
					margin-top: 100px;
				}
				.panel-button {
					margin-top: 32px;
					padding: 24px 0 28px 0;
					&-content {
						&--text {
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	.align-content-center {
		align-content: center;
	}
</style>
